import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    impactTitle: {
        display: 'flex',
        alignItems: 'center',
        marginTop: '20px',
        marginBottom: '10px',
        fontSize: '24px',
        lineHeight: 1.1,
        fontWeight: 600,
        color: theme.custom.textDarkSecondaryColor,
    },
    tooltipIcon: {
        marginLeft: '5px',
        color: theme.custom.iconColor,

        '&:hover': {
            cursor: 'pointer',
            color: theme.custom.iconColorHover,
        },
    },
    container: {
        position: 'relative',
        maxWidth: theme.custom.mainContentWidth,
        marginLeft: 'auto',
        marginRight: 'auto',
    },
    infoIcon: {
        marginLeft: '6px',
        fontSize: '28px',
        color: 'rgba(51,51,51,.25)',
        cursor: 'pointer',

        '&:hover': {
            color: 'rgba(51,51,51,.5)',
        },
    },
    infoTitle: {
        marginBottom: '10px',
        marginTop: '20px',
        fontSize: '30px',
        fontWeight: 600,
    },
    infoDescription: {
        margin: '0 0 20px',
        fontSize: '24px',
        lineHeight: 1.4,
    },
    editButton: {
        borderRadius: '6px',

        '& svg': {
            marginRight: '3px',
        },
    },
    profileImageContainer: {
        marginLeft: 'auto',
        marginRight: 'auto',
    },
    profileImage: {
        display: 'block',
        width: '188px',
        height: '188px',
        borderRadius: '6px',
        border: '1px solid rgba(255,255,255)',
    },
    profileName: {
        marginTop: '20px',
        marginBottom: '10px',
        textAlign: 'center',
        fontSize: '30px',
        fontWeight: 600,
        lineHeight: 1.1,
        color: theme.custom.textDarkColor,
    },
    profileHeadline: {
        fontSize: '14px',
        marginTop: '10px',
        marginBottom: '10px',
        fontWeight: 600,
        lineHeight: 1.1,
        textAlign: 'center',
        color: theme.custom.textDarkColor,
    },
    followContainer: {
        marginTop: '10px',
    },
    impactTotalsLabel: {
        fontSize: '24px',
        fontWeight: 600,
        marginTop: '40px',
        marginBottom: '10px',
        lineHeight: 1.1,
        color: theme.custom.textDarkSecondaryColor,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',

        '& svg': {
            cursor: 'pointer',
            marginLeft: '6px',
            color: 'rgba(51,51,51,.25)',

            '&:hover': {
                color: 'rgba(51,51,51,.5)',
            },
        },
    },
    activityTotals: {
        marginTop: '40px',
    },
}));

export default useStyles;
